import { Grid, Typography } from "@mui/material";
import { useEffect } from "react";
import { Controller, useForm, useWatch } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { APP_COLORS } from "../../../../enums";
import { defaultValues, environmentSchema, type EnvironmentFormData } from "./config";
import { ENVIRONMENT_LIST } from "./data";
import type { EditMyEnvironmentProps } from "./types";
import { getEnvironmentPayload, mapValueToFormValues } from "./utils";
import EnvironmentListItem from "./environment-list-item";

function EditMyEnvironment({
  value,
  onUpdateEnvironmentList,
}: EditMyEnvironmentProps) {
  const { control } = useForm({
    defaultValues: mapValueToFormValues(value) ?? defaultValues,
    resolver: zodResolver(environmentSchema),
  });

  const watched = useWatch({ control });

  useEffect(() => {
    const formValues =
      watched && typeof watched === "object" && "aws" in watched
        ? { ...defaultValues, ...watched }
        : mapValueToFormValues(value);
    onUpdateEnvironmentList(getEnvironmentPayload(formValues));
  }, [watched, value, onUpdateEnvironmentList]);

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      textAlign="center"
    >
      <Grid
        item
        xs={12}
        bgcolor={APP_COLORS.primaryLight2}
        borderRadius={2}
        height={40}
        display="flex"
        alignItems="center"
        justifyContent="center"
        mb={2}
      >
        <Typography variant="body-ibmPlexMono-medium" textAlign="center">
          Public Cloud Adoption
        </Typography>
      </Grid>
      <Grid item xs={12} mb={2}>
        {ENVIRONMENT_LIST.map((env) => (
          <Controller
            key={env.field}
            name={env.field as keyof EnvironmentFormData}
            control={control}
            render={({ field }) => (
              <EnvironmentListItem
                item={{ label: env.label, color: env.color }}
                value={field.value}
                onChange={field.onChange}
              />
            )}
          />
        ))}
      </Grid>
    </Grid>
  );
}

export default EditMyEnvironment;
